/***************************************************************************
 * ========================================================================
 * Copyright (c) 2026 Broadcom Inc. and/or its subsidiaries. All Rights Reserved. Broadcom Confidential.
 * ========================================================================
 */

/**
 * Module for all things Alert related.
 * @preferred
 * @module AlertModule
 */

import {
    CUSTOM_ELEMENTS_SCHEMA,
    NgModule,
    NO_ERRORS_SCHEMA,
} from '@angular/core';

import { CommonModule } from '@angular/common';
import { SharedModule } from 'ng/shared/shared.module';
import { AviFormsModule } from 'ng/modules/avi-forms/avi-forms.module';
import { DataGridModule } from 'ng/modules/data-grid/data-grid.module';
import { CoreModule } from 'ng/modules/core/core.module';

import {
    ActionGroupConfigModalComponent,
    AlertActionsListPageComponent,
    AlertConfigGridExpanderComponent,
    AlertConfigListPageComponent,
    AlertEmailModalComponent,
} from '.';

import {
    actionGroupConfigCollectionProvider,
    alertConfigCollectionProvider,
    alertEmailConfigCollectionProvider,
    alertMetricsCollectionProvider,
    controlScriptCollectionProvider,
    snmpTrapProfileCollectionProvider,
} from './ajs-upgraded-provider';

const alertComponents = [
    ActionGroupConfigModalComponent,
    AlertActionsListPageComponent,
    AlertConfigGridExpanderComponent,
    AlertConfigListPageComponent,
    AlertEmailModalComponent,
];

@NgModule({
    declarations: [
        ...alertComponents,
    ],
    imports: [
        AviFormsModule,
        CoreModule,
        CommonModule,
        DataGridModule,
        SharedModule,
    ],
    providers: [
        actionGroupConfigCollectionProvider,
        alertConfigCollectionProvider,
        alertEmailConfigCollectionProvider,
        alertMetricsCollectionProvider,
        controlScriptCollectionProvider,
        snmpTrapProfileCollectionProvider,
    ],
    schemas: [CUSTOM_ELEMENTS_SCHEMA, NO_ERRORS_SCHEMA],
})
export class AlertModule {}
